export function setupLazyLoading() {
  // Helper function to detect mobile device
  const isMobile = () => {
    return window.innerWidth <= 768 || /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  };

  // Helper function to get the appropriate src for the device
  const getImageSrc = (img) => {
    if (isMobile() && img.dataset.mobileSrc) {
      return img.dataset.mobileSrc;
    }
    return img.dataset.src;
  };

  // Check if IntersectionObserver is supported
  if (!('IntersectionObserver' in window)) {
    const lazyImages = document.querySelectorAll('img[data-src]');
    lazyImages.forEach(img => {
      img.onload = () => img.classList.add('loaded');
      const srcToUse = getImageSrc(img);
      if (srcToUse) {
        img.src = srcToUse;
      }
      img.removeAttribute('data-src');
      if (img.dataset.mobileSrc) {
        img.removeAttribute('data-mobile_src');
      }
      if (img.dataset.srcset) {
        img.srcset = img.dataset.srcset;
        img.removeAttribute('data-srcset');
      }
    });
    return;
  }

  const lazyImageObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const lazyImage = entry.target;

        // Get the appropriate src for the device
        const srcToUse = getImageSrc(lazyImage);

        if (srcToUse) {
          // Load image
          const img = new Image();
          img.onload = () => {
            lazyImage.src = srcToUse;
            lazyImage.classList.add('loaded');
          };
          img.src = srcToUse;
        }

        // Remove data attributes after use
          lazyImage.removeAttribute('data-src');
        if (lazyImage.dataset.mobileSrc) {
          lazyImage.removeAttribute('data-mobile_src');
        }

        // Handle srcset if present
        if (lazyImage.dataset.srcset) {
          lazyImage.srcset = lazyImage.dataset.srcset;
          lazyImage.removeAttribute('data-srcset');
        }

        // Stop observing the image
        observer.unobserve(lazyImage);
      }
    });
  }, {
    rootMargin: '100px' // Load images when they are 100px from entering the viewport
  });

  // Find and observe all lazy images
  const lazyImages = document.querySelectorAll('img[data-src]');
  lazyImages.forEach(img => {
    lazyImageObserver.observe(img);
  });
}